import React, { useEffect, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'

import BoxEngagement from 'Pages/RecipientsOverview/components/BoxEngagement'
import Header from 'Pages/RecipientsOverview/components/Header'
import ModalEngagementUpselling from 'Pages/RecipientsOverview/components/ModalEngagementUpselling'

import {
  initPageCallback,
  loadOptoutCallback,
  loadSubscriptionsEmailCallback,
  loadSubscriptionsSmsCallback,
  resetPageCallback,
} from 'Pages/RecipientsOverview/recoil/callbacks/overview'
import {
  optoutChartState,
  optoutEmptyStateState,
  subscriptionsEmailEmptyStateState,
  subscriptionsEmailState,
  subscriptionsSmsEmptyStateState,
  subscriptionsSmsState,
} from 'Pages/RecipientsOverview/recoil/state/overview'

import ChartWidget from 'Pages/RecipientsOverview/components/ChartWidget'

const RecipientsOverview: FC = () => {
  const intl = useIntl()

  const subscriptionsEmail = useRecoilValue(subscriptionsEmailState)
  const subscriptionsEmailEmptyState = useRecoilValue(
    subscriptionsEmailEmptyStateState,
  )

  const subscriptionsSms = useRecoilValue(subscriptionsSmsState)
  const subscriptionsSmsEmptyState = useRecoilValue(
    subscriptionsSmsEmptyStateState,
  )

  const optoutData = useRecoilValue(optoutChartState)
  const optoutEmptyState = useRecoilValue(optoutEmptyStateState)

  const initPage = useRecoilCallback(initPageCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  const loadSubscriptionsEmail = useRecoilCallback(
    loadSubscriptionsEmailCallback,
    [],
  )

  const loadSubscriptionsSms = useRecoilCallback(
    loadSubscriptionsSmsCallback,
    [],
  )

  const loadOptout = useRecoilCallback(loadOptoutCallback, [])

  useEffect(() => {
    void initPage()

    return () => {
      void resetPage()
    }
  }, [])

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />

      <ModalEngagementUpselling />

      <Page onReload={initPage}>
        <Flex flexDirection="column" gap="32px" margin="0 0 40px 0">
          <ChartWidget
            chartId="email-subscriptions-chart"
            title={intl.formatMessage({
              id: 'Load.RecipientsOverview.SubscriptionsEmailTitle',
            })}
            isEmptyState={subscriptionsEmailEmptyState}
            data={subscriptionsEmail.data}
            status={subscriptionsEmail.status}
            loading={subscriptionsEmail.loading}
            onReload={loadSubscriptionsEmail}
          />

          <ChartWidget
            chartId="sms-subscriptions-chart"
            title={intl.formatMessage({
              id: 'Load.RecipientsOverview.SubscriptionsSmsTitle',
            })}
            isEmptyState={subscriptionsSmsEmptyState}
            data={subscriptionsSms.data}
            status={subscriptionsSms.status}
            loading={subscriptionsSms.loading}
            onReload={loadSubscriptionsSms}
          />

          <ChartWidget
            chartId="optout-subscriptions-chart"
            title={intl.formatMessage({
              id: 'Load.RecipientsOverview.OptoutTitle',
            })}
            isEmptyState={optoutEmptyState}
            data={optoutData.data}
            status={optoutData.status}
            loading={optoutData.loading}
            onReload={loadOptout}
          />

          <BoxEngagement />
        </Flex>
      </Page>
    </>
  )
}

export default RecipientsOverview
